import {inject, Injectable} from '@angular/core';
import {SubsidyType} from '../../models/subsidy-type.type';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class TableService {
	#http = inject(HttpClient);

	get(subsidyType: SubsidyType, subsidyId: number, path: string): Observable<any[]> {
		return this.#http.get<any>(`/api12/${subsidyType}/subsidy/${subsidyId}/questiontable/${path}`).pipe(
			map((data) => data?.rows || []),
			catchError(() => of([])),
		);
	}

	set(subsidyType: SubsidyType, subsidyId: number, path: string, rows: any[]): Observable<any> {
		return this.#http.post(`/api12/${subsidyType}/subsidy/${subsidyId}/questiontable/${path}`, { rows });
	}
}
